import React from 'react';
import styled from 'styled-components';
import { SidebarSection, SidebarTitle, ModalHeader } from '../../styles/index';

export const errorInputStyle: React.CSSProperties = {
  borderColor: '#f44336',
  backgroundColor: '#fff8f8',
};

export const ModalHeaderRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 18px;
`;

export const ModalHeaderTitle = styled(ModalHeader)`
  margin: 0;
  flex: 1;
`;

export const FavoriteButton = styled.button<{ $active?: boolean }>`
  flex-shrink: 0;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 1.1rem;
  line-height: 1;
  padding: 2px 4px;
  border-radius: 6px;
  color: ${({ $active }) => ($active ? '#e53935' : '#bbb')};
  transition: color 0.15s ease, transform 0.1s ease;

  &:hover {
    transform: scale(1.2);
  }
`;

export const FieldErrorMessage = styled.div`
  color: #f44336;
  font-size: 0.8rem;
  margin-top: 4px;
`;

export const FieldSectionContainer = styled(SidebarSection)`
  margin-bottom: 20px;
  padding-bottom: 0;
  border-bottom: none;
`;

export const SubSectionTitle = styled(SidebarTitle)`
  font-size: 0.9rem;
  margin-top: 10px;
`;

export const DatesContainer = styled.div`
  font-size: 0.9rem;
  color: #616161;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const DateItem = styled.div`
  display: flex;
  flex-direction: column;
`;

export const DateValue = styled.strong`
  color: #333;
  margin-top: 2px;
  display: block;
`;
